import React from "react";
import {Link} from 'react-router-dom';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';

function Footer() {
    return(
        <Box px={{xs: 3, sm: 15}} pt={{xs: 3, sm: 3}} pb={{xs: 3, sm: 3}} bgcolor="#e6f0ff" color="text.primary">
            <Container maxWidth="xl">
                <Grid container spacing={5}>
                    {/* <Grid item xs={12} sm={4}>
                        <Box> <Typography variant="h5">Info</Typography> </Box>
                        <Box>
                            <Link to='/home'>Acasa</Link>
                        </Box>
                        <Box>
                            <Link to='/aboutus'>Despre noi</Link>
                        </Box>
                        <Box>
                            <Link to='/contactus'>Contact</Link>
                        </Box>
                    </Grid> */}
                    <Grid item xs={12} sm={8}>
                        <a href="https://aws.amazon.com/what-is-cloud-computing" target="_blank">
                            <img src="https://d0.awsstatic.com/logos/powered-by-aws.png" height="40%" alt="Powered by AWS Cloud Computing"/>
                        </a>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <Box> <Typography variant="h5">Adresa noastra</Typography> </Box>
                        <Box>
                            <Typography variant="caption">Strada Baba-Novac, Nr. 5, Bucuresti</Typography>
                        </Box>
                        <Box>
                            <Typography variant="caption">Sector 3, Cod Postal: 031622, Romania</Typography>
                        </Box>
                        <Box>
                            <PhoneIcon /> <Typography variant="caption">+40 728 851 440</Typography>
                        </Box>
                        <Box>
                            <MailIcon /> <a href="mailto:office@corevo.ro">office@corevo.ro</a>
                        </Box>
                    </Grid>
                </Grid>
                <Box textAlign="center" pt={{xs: 5, sm: 5}} pb={{xs: 5, sm: 0}}>
                    &reg; Copyright {new Date().getFullYear()} CorEvo Solutions
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;


